export default defineNuxtPlugin(() => {
  const runtimeConfig = useRuntimeConfig();
  const nuxtApp = useNuxtApp();
  const router = useRouter();

  (window as any).NAVACHAT_TOKEN = runtimeConfig.public.NAVA_CHAT_TOKEN;

  const { load, status } = useScript(
    {
      src: runtimeConfig.public.NAVA_CHAT_URL,
      defer: true,
      onload: () => { 
        console.log(
          "%cChat Box Loaded", 
          "font-weight: bold; background: #0066FE; color: #fff; padding: 10px; border-radius: 4px;"
        ) 
      },
      onerror: () => {},
    },
    { trigger: "manual" }
  );

  function handleLoadNavaChat() {
    const shouldShow = !router.currentRoute.value.meta.hideChatBox;
    if (shouldShow && status.value === "awaitingLoad") load();

    const el = document.getElementById("nava-chat");
    if (el) el.style.display = shouldShow ? "" : "none";
  }

  nuxtApp.hook("page:finish", handleLoadNavaChat);
  handleLoadNavaChat();
});